export default {
  'app.setting.pagestyle': 'Impostazione stile pagina',
  'app.setting.pagestyle.dark': 'Stile scuro',
  'app.setting.pagestyle.light': 'Stile chiaro',
  'app.setting.content-width': 'Larghezza contenuto',
  'app.setting.content-width.fixed': 'Fisso',
  'app.setting.content-width.fluid': 'Fluido',
  'app.setting.themecolor': 'Colore tema',
  'app.setting.themecolor.dust': 'Rosso polvere',
  'app.setting.themecolor.volcano': 'Vulcano',
  'app.setting.themecolor.sunset': 'Arancione tramonto',
  'app.setting.themecolor.cyan': 'Ciano',
  'app.setting.themecolor.green': 'Verde polare',
  'app.setting.themecolor.daybreak': 'Blu alba (predefinito)',
  'app.setting.themecolor.geekblue': 'Blu geek',
  'app.setting.themecolor.purple': 'Viola dorato',
  'app.setting.navigationmode': 'Modalità navigazione',
  'app.setting.sidemenu': 'Layout menu laterale',
  'app.setting.topmenu': 'Layout menu superiore',
  'app.setting.fixedheader': 'Header fisso',
  'app.setting.fixedsidebar': 'Barra laterale fissa',
  'app.setting.fixedsidebar.hint': 'Funziona con il layout menu laterale',
  'app.setting.hideheader': 'Header nascosto durante lo scorrimento',
  'app.setting.hideheader.hint': 'Funziona quando l\'header nascosto è abilitato',
  'app.setting.othersettings': 'Altre impostazioni',
  'app.setting.weakmode': 'Modalità per daltonici',
  'app.setting.copy': 'Copia impostazione',
  'app.setting.copyinfo':
    'copia riuscita, sostituisci defaultSettings in src/models/setting.js',
  'app.setting.production.hint':
    'Il pannello impostazioni è mostrato solo nell\'ambiente di sviluppo, modifica manualmente',
};